import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetKeywordList({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/keyword/list",
        params: {
          page: list.page,
          keyword: "*" + list.keyword + "*"
        },
        method: "GET"
      }).then(res => {
        console.log(res);
        resolve(res.data.payload);
      });
    });
  },
  PostKeyword({ commit }, keyword) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/keyword",
        data: keyword,
        method: "POST"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  PatchKeyword({ commit }, keyword) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/keyword/" + keyword.keyword_uuid,
        data: keyword.data,
        method: "PATCH"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  DeleteKeyword({ commit }, keyword_uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/keyword/" + keyword_uuid,
        method: "DELETE"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  GetKeyword({ commit }, keyword_uuid) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/keyword/" + keyword_uuid,
        method: "GET"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
